import { PitchConceptData } from "../../models/forms";
import { PitchConceptState } from "../../server/crm/api/models/forms";
import { ProgramsScope } from "../scopes";
import { createOnboardingAction } from "./helpers";

export enum PitchConceptActions {
  UPDATE_SINGLE_PITCH_CONCEPT = "@status/UPDATE_SINGLE_PITCH_CONCEPT",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pitchConceptActions: any = {
  updateSinglePitchConcept: createOnboardingAction(
    PitchConceptActions.UPDATE_SINGLE_PITCH_CONCEPT,
    ProgramsScope,
    (pitchConcept: PitchConceptData & PitchConceptState) => ({
      pitchConcept,
    })
  ),
};
